// @flow

import React from "react";
import SVG from "react-inlinesvg";
import Transition from "react-transition-group/Transition";

import Card from "../Card";
import SvgButton from "../SvgButton";
import contactIcon from "../../assets/icons/other/contact.svg";
import closeIcon from "../../assets/icons/other/x.svg";

import styles from "./ContactCard.scss";

const transitionStyles = {
  entering: { transform: `translateX(0)` },
  entered: { transform: `translateX(-100%)` },
  exiting: { transform: `translateX(-100%)` },
  exited: { transform: `translateX(0)` }
};

const FRESHCHAT_WIDGET_URL = "https://wchat.freshchat.com/js/widget.js";
const FRESHCHAT_TOKEN = "6de601f0-821d-43ba-9c7d-4b42c2f81c07";
const FRESHCHAT_HOST = "https://wchat.eu.freshchat.com";

type ContactCardProps = {
  phoneNumber: string,
  email: string
};

type ContactCardState = {
  isCardVisible: boolean
};

class ContactCard extends React.Component<ContactCardProps, ContactCardState> {
  state = {
    isCardVisible: false
  };

  setCardVisible = (status: boolean) => this.setState({ isCardVisible: status });

  componentDidMount = () => {
    this.appendWidgetScript();
  };

  appendWidgetScript = () => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = FRESHCHAT_WIDGET_URL;
    script.onload = this.setupChat;
    document.head.appendChild(script);
  };

  setupChat = () => {
    window.fcWidget.init({
      token: FRESHCHAT_TOKEN,
      host: FRESHCHAT_HOST,
      open: false,
      config: {
        headerProperty: {
          hideChatButton: true
        }
      }
    });
  };

  openChat = () => {
    this.setCardVisible(false);
    window.fcWidget.open();
  };

  render = () => {
    const { phoneNumber, email } = this.props;
    const { isCardVisible } = this.state;

    return (
      <Transition appear in={isCardVisible} timeout={300}>
        {state => (
          <Card
            style={transitionStyles[state]}
            additionalCardStyles={styles.cardContainer}
            action={() => (
              <SvgButton
                src={closeIcon}
                className={styles.closeButton}
                onClick={() => this.setCardVisible(false)}
              />
            )}
          >
            <button
              className={styles.ribbon}
              type="button"
              onClick={() => this.setCardVisible(!isCardVisible)}
            >
              <SVG src={contactIcon} className={styles.contactIcon} />
              <span className={styles.contact}>Kontakt</span>
            </button>
            <div>
              <header>Kontakt</header>
              <span className={styles.highlighted}>
                Sie haben Fragen zum Ermoeglicherportal der Bürgschaftsbanken?
              </span>
              <span className={styles.highlighted}>(Mo-Fr 9 bis 18 Uhr)</span>
              <span className={styles.highlighted}>Telefonnummer</span>
              <span className={styles.personInfo}>{phoneNumber}</span>
              <span className={styles.highlighted}>E-Mail</span>
              <span className={styles.email}>
                <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
                  {email}
                </a>
              </span>
              <span className={styles.highlighted}>Chat</span>
              <span className={styles.personInfo}>
                <button type="button" className={styles.linkButton} onClick={this.openChat}>
                  Jetzt Chat starten
                </button>
              </span>
            </div>
          </Card>
        )}
      </Transition>
    );
  };
}

export default ContactCard;
